export const randomIntFromInterval = (min: number, max: number) => {
    return Math.floor(Math.random() * (max - min + 1) + min)
}

export const randomFloatFromInterval = (min: number, max: number) => {
    return parseFloat((Math.random() * (max - min + 1) + min).toFixed(2))
}